// extracted by mini-css-extract-plugin
export var container = "_c6-0";
export var icon = "_c6-1";
export var text = "_c6-2";